"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import Image from "next/image";
import { motion } from "framer-motion";
import { FaAndroid, FaApple } from "react-icons/fa";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function CrmCaseStudy() {
  const $ = _c(37);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      once: true,
      amount: 0.3
    };
    t4 = {
      duration: 0.7,
      ease
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="font-poppins mb-5 text-[28px] font-bold leading-[1.35] text-[#0b1354] md:text-[40px] dark:text-white">Build High-Performance eCommerce Apps with Our Proven Expertise</h2>;
    t6 = <p className="mx-auto mb-0 max-w-[880px] font-sans text-[16px] font-normal leading-[31px] text-[#6b7280] md:text-[17px] dark:text-gray-400">With expertise in eCommerce apps, PWAs, and web portals, we deliver dynamic and immersive online shopping experiences for our clients.</p>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2) {
    t7 = <motion.div initial={t0} whileInView={t1} animate={t2} viewport={t3} transition={t4} className="mx-auto mb-11 max-w-[900px] text-center">{t5}{t6}</motion.div>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== desktopAnimations) {
    t8 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[14] = desktopAnimations;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[16] = desktopAnimations;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== desktopAnimations) {
    t10 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[18] = desktopAnimations;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      once: true,
      amount: 0.2
    };
    t12 = {
      duration: 0.75,
      ease
    };
    $[20] = t11;
    $[21] = t12;
  } else {
    t11 = $[20];
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Image src="/images/crm/decornt-logo.png" alt="DECORNT" width={430} height={120} className="mb-6 h-auto w-[215px] object-contain dark:bg-white dark:p-3 dark:rounded" />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="inline-flex items-center gap-2 rounded-[8px] border border-white bg-white px-4 py-2 font-sans text-[15px] text-[#4b5563] shadow-[0_2px_8px_rgba(20,60,100,0.06)] dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300"><FaAndroid className="text-[16px] text-[#3ddc84]" />Android</span>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  let t16;
  let t17;
  let t18;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="mb-7 flex flex-wrap items-center gap-3.5">{t14}<span className="inline-flex items-center gap-2 rounded-[8px] border border-white bg-white px-4 py-2 font-sans text-[15px] text-[#4b5563] shadow-[0_2px_8px_rgba(20,60,100,0.06)] dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300"><FaApple className="text-[16px] text-[#0b1354] dark:text-white" />iPhone</span></div>;
    t16 = <h3 className="font-poppins mb-4 text-[18px] font-bold text-[#0b1354] dark:text-white">DECORNT</h3>;
    t17 = <p className="mb-9 max-w-[500px] font-sans text-[16px] leading-[30px] text-[#6b7280] md:text-[17px] dark:text-gray-300">{"DECORNT is a B2B e-commerce company specialized in buying & selling of material used in Wedding Events, Catering, Hotel ware, Decoration with the facility of home delivery & cash on delivery (COD) facility across India."}</p>;
    t18 = <p className="font-poppins mb-4 text-[20px] font-bold text-[#0b1354] dark:text-white">The Result?</p>;
    $[24] = t15;
    $[25] = t16;
    $[26] = t17;
    $[27] = t18;
  } else {
    t15 = $[24];
    t16 = $[25];
    t17 = $[26];
    t18 = $[27];
  }
  let t19;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div>{t13}{t15}{t16}{t17}{t18}<div className="flex flex-wrap gap-x-[70px] gap-y-8"><div><p className="font-poppins mb-1.5 text-[26px] font-bold leading-none text-[#0b1354] dark:text-white">500+</p><p className="mb-0 max-w-[190px] font-sans text-[16px] leading-[30px] text-[#6b7280] md:text-[17px] dark:text-gray-300">Increase in Orders Coming Through App</p></div><div><p className="font-poppins mb-1.5 text-[26px] font-bold leading-none text-[#0b1354] dark:text-white">30%</p><p className="mb-0 max-w-[190px] font-sans text-[16px] leading-[30px] text-[#6b7280] md:text-[17px] dark:text-gray-300">Increase in Conversion Rate</p></div></div></div>;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-12">{t19}<div className="relative flex justify-center"><Image src="/images/crm/decornt-devices.png" alt="DECORNT app" width={1200} height={600} className="relative z-10 h-auto w-full max-w-[640px] object-contain" /></div></div>;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t10 || $[31] !== t8 || $[32] !== t9) {
    t21 = <motion.div initial={t8} whileInView={t9} animate={t10} viewport={t11} transition={t12} className="overflow-hidden rounded-[16px] bg-[#d9f0fd] dark:bg-gray-800/90 dark:border dark:border-gray-700/80 px-6 py-10 md:px-[52px] md:py-[60px]">{t20}</motion.div>;
    $[30] = t10;
    $[31] = t8;
    $[32] = t9;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== t21 || $[35] !== t7) {
    t22 = <section className="bg-white py-[70px] transition-colors duration-300 md:py-[100px] dark:bg-gray-950"><div className="mx-auto w-full max-w-[1290px] px-[15px]">{t7}{t21}</div></section>;
    $[34] = t21;
    $[35] = t7;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  return t22;
}